import { changePassword } from './changePassword';
import { login } from './login';
import { register } from './register';
import { resetPassword } from './resetPassword';
import { logout } from './logout';
import { retrieveRegistrationToken } from './retrieveRegistrationToken';
import { refreshAuthToken } from './refresh-token';
import { retrieveUserToken } from './retrieveUserToken';

export const IdentityAPI = {
    changePassword,
    login,
    logout,
    register,
    resetPassword,
    retrieveRegistrationToken,
    refreshAuthToken,
    retrieveUserToken,
};

export * from './types';
